import { Directive } from '@angular/core';
import { AbstractControl, Validator, ValidatorFn } from '@angular/forms';
import * as _ from 'lodash';

export enum TimeFormatErrors {
  invalidFormat = 'invalidFormat',
}

export function timeFormatValidatorFunction(): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null => {
    if (!_.isEmpty(control.value)) {
      // validate the control value is in the form "HH:MM",
      // where HH is between [00, 23], and MM is between [00, 59]
      const parts = _.split(control.value, ':');
      const hours = _.parseInt(parts[0]);
      const minutes = _.parseInt(parts[1]);

      if (!_.inRange(hours, 24) || !_.inRange(minutes, 60)) {
        // time entered was invalid
        return { [TimeFormatErrors.invalidFormat]: true };
      }
    }
    return null;
  };
}

@Directive({
  selector: '[timeFormatValidator]',
})
export class TimeFormatValidator implements Validator {
  constructor() {}

  validate(control: AbstractControl): { [key: string]: any } | null {
    return timeFormatValidatorFunction()(control);
  }
}
